<template>
    <div  class="container md:mt-24 mt-16">
        <div class="grid grid-cols-1 pb-8 text-center">

            <SectionTitleComponent :title="'Partners'" />
        </div>

        <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-8 gap-[30px]">

            <div v-for="item in datas" :key="item" class="group relative p-6 rounded-md shadow dark:shadow-gray-700 mt-6">
                <div class="size-14 overflow-hidden flex items-center justify-center bg-white dark:bg-slate-900 shadow-md dark:shadow-gray-700 rounded-md relative -mt-12">
                    <a :href="item.link" target="_blank" class="text-lg hover:text-amber-300 font-semibold">
                        <img :src="item.image" class="size-14" alt="">
                    </a>
                </div>

                <div class="mt-4">

                    <a :href="item.link" target="_blank" class="text-lg hover:text-amber-300 font-semibold">{{ item.name }}</a>
                    <p class="text-slate-400 mt-2">{{ item.desc }}</p>
                </div>

                <div class="mt-4 pt-4 border-t border-gray-100 flex justify-between">
                    <span class="text-slate-400"><i class="uil uil-map-marker"></i> {{ item.city }}</span>
                    <span class="block font-semibold text-emerald-600">{{ item.jobs }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SectionTitleComponent from '@/components/SectionTitleComponent.vue';

export default {
    components: {
        SectionTitleComponent
    },
    data() {
        return {
            datas: [
                {
                    id: 1,
                    image: require('../assets/images/gems.png'),
                    name: 'BC Gems Diepenbeek',
                    city: 'Diepenbeek',
                    desc: 'Blessurepreventie en core stability binnen de jeugdwerking.',
                    link: 'https://www.gemsdiepenbeek.be/'
                },
                {
                    id: 2,
                    image: require('../assets/images/wbikes.png'),
                    name: 'W-Bikes',
                    city: 'Diepenbeek',
                    desc: 'Prestatiegerichte maatwerk fietsen, bikefitting.',
                    link: 'https://w-bikes.be/'
                },
                {
                    id: 3,
                    image: require('../assets/images/add.png'),
                    name: 'ADD Diepenbeek',
                    city: 'Diepenbeek',
                    desc: 'Atletiek Diepenbeek',
                    link: 'https://addemer.com/adddiepenbeek/'
                },
                {
                    id: 4,
                    image: require('../assets/images/runeasi.png'),
                    name: 'Runeasi',
                    city: 'Hasselt',
                    desc: 'Loopanalyse technologie',
                    link: 'https://runeasi.ai'
                }
            ]

        }
    },
}
</script>

<style lang="scss" scoped></style>